module.exports = __webpack_public_path__ + "img/call.d40fa888.svg";